import { Button, Flex, Skeleton } from 'antd'
import { FormattedMessage } from 'react-intl'
import cn from 'classnames'
import FormattedCurrency from 'shared/components/FormattedCurrency'
import { DEFAULT_BASE_CURRENCY } from '../DonationForm/constants'
import s from './s.module.css'
import { lang } from './lang'
import { useQuickAmounts } from './hooks/useQuickAmounts'

type Props = {
  fiatAmount: string
  onAmountClick: (value: string) => void
  minAmountInBaseCurrency: number | null
  loading: boolean
  baseCurrencyCode?: string
}

export default function QuickAmounts({
  fiatAmount,
  onAmountClick,
  baseCurrencyCode,
  minAmountInBaseCurrency,
  loading,
}: Props) {
  const quickFiatAmounts = useQuickAmounts({
    baseCurrencyCode: baseCurrencyCode ?? DEFAULT_BASE_CURRENCY,
    minAmountInBaseCurrency,
  })

  return (
    <Flex gap={8} className={s.quickButtons} wrap>
      {quickFiatAmounts.map((item, key) => {
        if (item && loading) {
          return <Skeleton.Button size="small" key={key} />
        }

        const isSelected = Number(fiatAmount) === item.value
        return (
          <Button
            disabled={loading}
            key={key}
            size="small"
            onClick={() => onAmountClick(item.value.toString())}
            type={isSelected ? 'primary' : 'default'}
            className={cn(!isSelected && s.focus)}
          >
            <>
              {item.isMin && (
                <>
                  <FormattedMessage {...lang.min} />{' '}
                </>
              )}
              <FormattedCurrency value={item.value} currency={baseCurrencyCode} />
            </>
          </Button>
        )
      })}
    </Flex>
  )
}
